import { useCommon } from '@/core/useCommon'
import { Platform } from '@/env'
import { setLocale } from '@/i18n'
import { Language, languageLabelMap } from './constant'
import { useMemo } from 'react'

// 選擇語系 Hook
export const useSelectLang = () => {
  const { locale } = useCommon()
  // 語系列表
  const localesOptions = useMemo(() => {
    return Platform.LOCALES.map((lang) => ({
      value: lang,
      label: languageLabelMap.get(lang as Language),
    }))
  }, [Platform.LOCALES])

  return {
    languageLabelMap,
    localesOptions,
    locale, // 當前語系
    setLocale,
  }
}
